import styled from 'styled-components';
import { Button, Card } from 'antd';

// Styled components for Module Management page
export const ForbiddenWrapper = styled.div`
  text-align: center;
  padding: 50px;
`;

export const SubModuleCard = styled(Card)`
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: #FFF;
`;

export const SubModuleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
`;

export const DeleteIconWrapper = styled.span`
  cursor: pointer;
  color: #ff4d4f;
`;

export const AddSubModuleButton = styled(Button)`
  margin-top: 16px;
`;

